module.exports = __webpack_public_path__ + "img/capsulas_gelatina.f046bb2b.svg";